import React, { useState } from 'react';

import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import PayloadBuilderSetupGuideModal from './PayloadBuilderSetupGuideModal';
import { PAYLOAD_BUILDER_ALERT_BUTTON_SX } from './PayloadBuilderConstants';
import type { PayloadBuilderMode } from './PayloadBuilderToolbar';

interface PayloadBuilderSetupGuideProps {
  selectedMode: PayloadBuilderMode;
}

const BUTTON_LABEL: Record<PayloadBuilderMode, string> = {
  statusMatch: 'How to Create a Campaign',
  statusClaim: 'How to Create a Campaign',
  offersHub: 'How to Customise the Page',
};

export default function PayloadBuilderSetupGuide({ selectedMode }: PayloadBuilderSetupGuideProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="info"
        startIcon={<InfoOutlinedIcon fontSize="small" />}
        onClick={() => setIsOpen(true)}
        sx={PAYLOAD_BUILDER_ALERT_BUTTON_SX}
      >
        {BUTTON_LABEL[selectedMode]}
      </Button>
      <PayloadBuilderSetupGuideModal selectedMode={selectedMode} open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
